/* TPL grid density switch (2026-09-07) — collection grid only.
   Buttons carry data-tpl-density = columns. Stored in localStorage and clamped
   per breakpoint: phones 1–2, tablet 2–3, desktop 2–4. */
(function () {
  'use strict';
  var KEY = 'tpl_grid_density';
  function range() {
    var w = window.innerWidth;
    if (w < 550) return [1, 2];
    if (w < 990) return [2, 3];
    return [2, 4];
  }
  function read() {
    try { var v = parseInt(localStorage.getItem(KEY), 10); return isNaN(v) ? null : v; } catch (e) { return null; }
  }
  function write(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) { /* private mode */ } }
  /* FLIP (motion.dev "Layout animation", 2026-09-08): on a tap, cards glide to
     their new cell instead of snapping. Measure, switch, measure, invert, play. */
  var EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
  function flip(grid, mutate) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.tpl-cpg__item')).filter(function (el) { return el.offsetParent !== null; }).slice(0, 40);
    if (reduced || !items.length || typeof Element.prototype.animate !== 'function') { mutate(); return; }
    var first = items.map(function (el) { return el.getBoundingClientRect(); });
    mutate();
    items.forEach(function (el, i) {
      var last = el.getBoundingClientRect(), f = first[i];
      if (!last.width || !f.width) return;
      var dx = f.left - last.left, dy = f.top - last.top, sx = f.width / last.width, sy = f.height / last.height;
      if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sx - 1) < 0.01) return;
      el.style.transformOrigin = '0 0';
      el.animate([{ transform: 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + sx.toFixed(4) + ',' + sy.toFixed(4) + ')' }, { transform: 'none' }], { duration: 520, delay: Math.min(i, 12) * 12, easing: EXPO });
    });
  }
  function apply(animate) {
    var grid = document.querySelector('[data-tpl-density-grid]');
    var sw = document.querySelector('[data-tpl-density-switch]');
    if (!grid || !sw) return;
    var r = range();
    var stored = read();
    var eff = stored === null ? null : Math.min(r[1], Math.max(r[0], stored));
    var setAttr = function () {
      if (eff === null) grid.removeAttribute('data-density');
      else grid.setAttribute('data-density', String(eff));
    };
    if (animate) flip(grid, setAttr); else setAttr();
    /* Perf 2026-09-11: keep the <img sizes> honest. The markup ships 50vw for
       the 2-column phone grid; only a 1-per-row pick needs 100vw. */
    var oneUp = r[0] === 1 && eff === 1;
    grid.querySelectorAll('.tpl-cpg__image').forEach(function (img) {
      var want = oneUp ? '100vw' : '(min-width: 990px) 50vw, 50vw';
      if (img.getAttribute('sizes') !== want) img.setAttribute('sizes', want);
    });
    sw.querySelectorAll('[data-tpl-density]').forEach(function (b) {
      var v = parseInt(b.getAttribute('data-tpl-density'), 10);
      var inRange = v >= r[0] && v <= r[1];
      b.hidden = !inRange;
      var defAttr = r[0] === 1 ? 'data-default-mobile' : (r[1] === 3 ? 'data-default-tablet' : 'data-default-desktop');
      var def = parseInt(grid.getAttribute(defAttr) || '2', 10);
      var current = eff === null ? Math.min(r[1], Math.max(r[0], def)) : eff;
      b.setAttribute('aria-pressed', v === current ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-tpl-density]') : null;
    if (!b) return;
    e.preventDefault();
    write(parseInt(b.getAttribute('data-tpl-density'), 10));
    apply(true);
  });
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
